import { render, staticRenderFns } from "./AssessmentPanel.vue?vue&type=template&id=08968c26&"
import script from "./AssessmentPanel.vue?vue&type=script&lang=js&"
export * from "./AssessmentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports